import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { router, usePage } from "@inertiajs/react";

const LOCALE_LABELS: Record<string, string> = {
  en: "English",
  es: "Español",
};

export default function LanguageSwitcher() {
  const { props, url } = usePage();
  const { locale } = props;

  function onLocaleChange(newLocale: string) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set("locale", newLocale);
    router.visit(nextUrl.pathname + nextUrl.search, { preserveScroll: true });
  }

  return (
    <Select value={locale} onValueChange={onLocaleChange}>
      <SelectTrigger size="sm" className="w-fit" aria-label="Language">
        <SelectValue>{LOCALE_LABELS[locale]}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.entries(LOCALE_LABELS).map(([value, label]) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
